import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { api } from '@/redux/api';

/**
 * Shared between the trigger (this modal) and any observer (the table view) so
 * the in-flight delete state — including its `originalArgs` — is readable from
 * both via RTK Query's mutation cache.
 */
export const BREAK_CONNECTION_CACHE_KEY = 'breakFfConnection';

type ConfirmBreakConnectionModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onSend: () => void;
  unitId: number;
  connectionId: number;
  relative?: string | null;
};

export default function ConfirmBreakConnectionModal({
  isOpen,
  onCancel,
  onSend,
  unitId,
  connectionId,
  relative,
}: ConfirmBreakConnectionModalProps) {
  const [deleteConnection] = api.useDeleteUnitFfConnectionMutation({
    fixedCacheKey: BREAK_CONNECTION_CACHE_KEY,
  });

  return (
    <Modal
      buttonItems={[
        <Button key="cancel" onClick={onCancel} variant="secondary">
          Cancel
        </Button>,
        <Button
          key="confirm"
          onClick={async () => {
            onSend();
            await deleteConnection({ unitId, connectionId });
          }}
          variant="primary-warning"
        >
          Break connection
        </Button>,
      ]}
      open={isOpen}
      setOpen={onCancel}
      title="Break connection"
    >
      <div className="px-6 pb-4 text-sm text-gray-500">
        <p>
          Break the connection with {relative ?? 'this phone'}? They will lose
          access immediately and the relative slot will free up. This cannot be
          undone.
        </p>
      </div>
    </Modal>
  );
}
